﻿import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";

import { getMaintainers } from "@/api/Maintainers/maintainers";

import Fetching from "@/components/Fetching/Fetching";
import { formatMiles } from "@/services/Utils";

import classes from "./maintainers.module.scss";

const Maintainers = () => {
	const navigate = useNavigate();

	const { data: maintainers, isLoading } = useQuery(["maintainers"], getMaintainers);

	if (isLoading) {
		return <Fetching />;
	}

	return (
		<>
			{maintainers &&
				maintainers.map((maintainer, i) => {
					return (
						<Fragment key={i}>
							<div className={classes.main_title}>{maintainer.name}</div>
							<div className={classes.maintainers}>
								{maintainer.options.map((option, j) => {
									return (
										<div className={classes.item} key={j}>
											<div className={classes.target} onClick={() => navigate(option.path)}>
												<div className={classes.title}>{option.name}</div>
												<hr className={classes.hr} />
												<div className={classes.subtitle}>
													<small>{`${formatMiles(option.quantity)} elementos registrados`}</small>
												</div>
											</div>
										</div>
									);
								})}
							</div>
						</Fragment>
					);
				})}
		</>
	);
};

export default Maintainers;
